import { isArray } from "lodash";

export const autoCompare = (
  valueA: any,
  valueB: any,
  valueType: "string" | "number" = "string",
  direction: "desc" | "asc" = "asc",
  condition?: boolean //при котором автоматом значение наверх
): number => {
  if (condition) return -1;

  let result: number = 0;

  if (valueType === "number") {
    const numA = Number(valueA) || 0;
    const numB = Number(valueB) || 0;
    result = numA - numB;
  } else {
    const strA = String(valueA ?? "").toLowerCase();
    const strB = String(valueB ?? "").toLowerCase();
    result = strA.localeCompare(strB);
  }

  return direction === "asc" ? result : -result;
};

export const getSortDescending = (
  array: any[],
  field?: string | string[], //если поле вложенное, путь до него по порядку в массиве
  options: {
    condition?: boolean | ((arg: any) => boolean);
    type?: "string" | "number";
  } = { type: "string" }
) => {
  if (Array.isArray(array)) {
    return array.sort((a, b) => {
      const finalCondition =
        options?.condition &&
        (typeof options.condition === "function"
          ? options.condition(a)
          : options.condition);

      if (field && isArray(field)) {
        let finalFieldA = { ...a };
        let finalFieldB = { ...b };
        for (let dataField of field) {
          finalFieldA = finalFieldA[dataField];
          finalFieldB = finalFieldB[dataField];
        }
        return autoCompare(
          finalFieldA,
          finalFieldB,
          options.type,
          "desc",
          finalCondition
        );
      } else if (field) {
        return autoCompare(
          a[field],
          b[field],
          options.type,
          "desc",
          finalCondition
        );
      } else {
        return autoCompare(a, b, options.type, "desc", finalCondition);
      }
    });
  } else {
    return [];
  }
};

export const getSortAscending = <T>(
  array: T[],
  field?: string | string[], //если поле вложенное, путь до него по порядку в массиве
  options: {
    condition?: boolean | ((arg: T) => boolean);
    type?: "string" | "number";
  } = { type: "string" }
): T[] => {
  if (Array.isArray(array)) {
    return [...array].sort((a, b) => {
      const finalCondition =
        options?.condition &&
        (typeof options.condition === "function"
          ? options.condition(a)
          : options.condition);

      if (field && Array.isArray(field)) {
        let finalFieldA: any = a;
        let finalFieldB: any = b;
        for (let dataField of field) {
          finalFieldA = finalFieldA?.[dataField];
          finalFieldB = finalFieldB?.[dataField];
        }
        return autoCompare(
          finalFieldA,
          finalFieldB,
          options.type,
          "asc",
          finalCondition
        );
      } else if (field) {
        return autoCompare(
          (a as any)[field],
          (b as any)[field],
          options.type,
          "asc",
          finalCondition
        );
      } else {
        return autoCompare(a, b, options.type, "asc", finalCondition);
      }
    });
  } else {
    return [];
  }
};
